import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import Boletos from "./Boletos";
import Fatura from "./Fatura";

export default function Index({ match }) {
  return (
    <div className="content-wrapper">
      <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/boletos`} />
        <Route path={`${match.url}/boletos`} component={Boletos} />
        <Route path={`${match.url}/fatura/:ano/:mes`} component={Fatura} />
      </Switch>
    </div>
  );
}
